<template>
  <b-container v-if="tree.children && tree.children.length > 0">
    <b-row>
      <b-col cols="11" style="text-align: left"> <h6>{{$t('label_evaluation_report_scoreByDimensions_requirementsTitle')}}</h6> </b-col>
      <b-col cols="1" style="white-space: nowrap"> <h6>{{$t('label_evaluation_report_scoreByDimensions_scoreTitle')}}</h6> </b-col>
    </b-row>
    <b-row v-for="(child, childKey) in tree.children" :key="childKey">
      <b-col cols="11">
        {{ child.evaluation_administrator_node_nomenclature }}
        {{ child.evaluation_administrator_node_requirementName }}
      </b-col>
      <b-col cols="1" style="white-space: nowrap">
        {{ getChildPercentage(child).toFixed(2) }} %
      </b-col>
    </b-row>
  </b-container>
</template>
<script >
export default {
  name: "EvaluationReportTreeList",
  props: {
    tree: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {};
  },
  methods: {
    getChildPercentage(child) {
      if (!child.children || !child.children.length) {
        return child.evaluation_status ? child.evaluation_status : 0;
      } else {
        return child.evaluation_status &&
          child.evaluation_administrator_node_percentualWeight
          ? (child.evaluation_status * 100) /
              child.evaluation_administrator_node_percentualWeight
          : 0;
      }
    },
  },
};
</script >
